import { useEffect, useState } from 'react'
import { Ticket, Trophy } from 'lucide-react'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { meAPI } from '@/lib/api'

/* RaffleHomeWidget — compacte kaart naast KassaHomeWidget.
   Toont ticket-count + progress-bar naar volgende ticket (uit
   raffle_progress in /me/home-widgets). Verbergt zich als de raffle-module
   uit staat of user niet gekoppeld is aan kassa (raffle_progress = null
   én raffle_count = 0). */

function euro(cents) {
  return `€${(cents / 100).toFixed(2).replace('.', ',')}`
}

export default function RaffleHomeWidget() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    let alive = true
    const load = () => meAPI.homeWidgets()
      .then(r => alive && setData(r.data))
      .catch(() => alive && setData({}))
      .finally(() => alive && setLoading(false))
    load()
    const t = setInterval(load, 60_000)
    return () => { alive = false; clearInterval(t) }
  }, [])

  if (loading) return null
  const count = Number(data?.raffle_count || 0)
  const p = data?.raffle_progress
  if (count === 0 && !p) return null

  const pct = p ? Math.max(0, Math.min(100, ((p.threshold_cents - p.cents_to_next) / p.threshold_cents) * 100)) : null

  return (
    <Card className="border-neon-yellow/30 bg-gradient-to-br from-card to-neon-yellow/5">
      <CardHeader className="pb-3">
        <div className="flex items-center gap-2">
          <Ticket className="h-5 w-5 text-neon-yellow" />
          <CardTitle className="text-lg text-neon-yellow">Raffle-tickets</CardTitle>
        </div>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex items-baseline gap-2">
          <span className="text-3xl font-bold tabular-nums">{count}</span>
          <span className="text-sm text-muted-foreground">
            {count === 1 ? 'ticket' : 'tickets'}
          </span>
        </div>

        {p && (
          <>
            <div>
              <div className="flex items-center justify-between text-xs mb-1">
                <span className="text-muted-foreground">Tot volgende ticket</span>
                <span className="font-mono tabular-nums">{euro(p.cents_to_next)}</span>
              </div>
              <div className="h-2 rounded-full bg-muted overflow-hidden">
                <div
                  className="h-full bg-neon-yellow transition-all"
                  style={{ width: `${pct}%` }}
                />
              </div>
              <div className="text-[10px] text-muted-foreground mt-1">
                Besteed: {euro(p.spent_cents)} · 1 ticket per {euro(p.threshold_cents)}
              </div>
            </div>
          </>
        )}

        <div className="pt-2 border-t border-border text-xs text-muted-foreground flex items-start gap-2">
          <Trophy className="h-4 w-4 text-neon-yellow shrink-0 mt-0.5" />
          <span>Tickets inleveren bij een compo-admin tijdens de trekking.</span>
        </div>
      </CardContent>
    </Card>
  )
}
